module.exports = __webpack_public_path__ + "static/media/picto-twitter.52d0a64d.svg";